// extracted by mini-css-extract-plugin
module.exports = {"Ask":"Ask_Ask__1231m","Ask__child":"Ask_Ask__child__40S8Z","Ask__childContent":"Ask_Ask__childContent__30j_f"};